import {FormatterBasic} from "./Core/FormatterBasic";

export class AddressFormatter extends FormatterBasic {
    Format(): string {
        return this.GetValue('Value');
    }

}